module.exports = __webpack_public_path__ + "img/marker-blue.f3d1a919.svg";